import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import EntityTableProvider from '../entity-table-provider/entity-table-provider.vue';
import {
  AccountingIntegrationSettings,
  SyncServiceName,
  SyncServiceType,
} from '@accounting-integrations/interfaces/accounting-integrations';

@Component({
  components: {},
})
export default class PaymentSyncMixin extends Vue {
  declare $refs: {
    provider: InstanceType<typeof EntityTableProvider> & {
      getEntities(): Promise<void>;
      exportAll(): Promise<void>;
      exportCancel(): Promise<void>;
      downloadingExport: boolean;
    };
  };

  public showPaymentSyncModal = false;
  public showPaymentSyncSettingForm = false;
  public paymentSyncEventsError = [];
  public paymentSyncEventsSuccess = [];
  public paymentSyncRequestSent = false;
  public isSyncingPayments = false;
  public paymentSyncSessionCode: string = null;
  public declare selection;
  public sessionCode: string = null;

  onSyncPayments() {
    this.paymentSyncEventsError = [];
    this.paymentSyncEventsSuccess = [];
    this.paymentSyncRequestSent = false;
    this.isSyncingPayments = false;
    this.showPaymentSyncSettingForm = false;
    this.paymentSyncSessionCode = null;
    this.showPaymentSyncModal = true;
  }

  destroyed() {
    if (this.sessionCode) {
      this.$bpcEcho.leavePaymentSyncChannel(this.sessionCode);
    }
  }

  get accountingIntegrationSettings(): AccountingIntegrationSettings {
    if (this.$modulesService.hasModuleActivated('accounting_integrations')) {
      return this.$store.getters['centerSettings/accountingIntegrationSettings'];
    }

    return null;
  }

  get syncServiceName(): SyncServiceName {
    return this.accountingIntegrationSettings?.sync_service;
  }

  onClosePaymentSyncConfirmModal() {
    this.showPaymentSyncModal = false;
    this.showPaymentSyncSettingForm = false;
  }

  onConfirmPaymentSyncAll() {
    // TODO implemente a real process ALL function
    const processAll = true;
    this.onConfirmPaymentSync(processAll);
  }

  onConfirmPaymentSync(processAll: boolean = false) {
    if (this.sessionCode) {
      this.$bpcEcho.leavePaymentSyncChannel(this.sessionCode);
    }

    const basePath = this.$bpcApiRouteHelper.getEntityPath('invoice-sync-items');
    this.sessionCode = `invoice-table-${Date.now()}`;
    this.paymentSyncSessionCode = this.sessionCode;
    this.listenToWebsocketPaymentSyncChannel(this.sessionCode);
    this.paymentSyncRequestSent = true;

    this.$bpcApi
      .post(basePath + '/sync-payments', {
        invoices: this.selection,
        session_code: this.sessionCode,
        process_all: processAll,
      })
      .subscribe(
        res => {
          this.$refs.provider.getEntities();
          // this.showPaymentSyncModal = false;
          this.paymentSyncRequestSent = true;
        },
        error => {
          this.managePaymentSyncError(error);
        },
      );
  }

  listenToWebsocketPaymentSyncChannel(sessionCode) {
    this.isSyncingPayments = true;

    this.$bpcEcho
      .getPaymentSyncChannel(sessionCode)
      .listen('.BPC\\AccountingIntegrations\\Events\\BulkPaymentSynced', data => {
        // console.log('PaymentSyncItemBulkProcessed', data);
        this.$bpcMessage.showInfoMessage({
          text: 'global.accounting.invoices.all_invoice_payment_synced_reload_page',
        });
        this.isSyncingPayments = false;
        this.$refs.provider.getEntities();
        // this.$bvModal.hide('modal-generate-invoices');
      })
      .listen('.BPC\\AccountingIntegrations\\Events\\PaymentSynced', data => {
        // console.log('PaymentSyncItemProcessed', data);
        this.paymentSyncEventsSuccess.push(data);
      })
      .listen('.BPC\\AccountingIntegrations\\Events\\PaymentSyncError', data => {
        // console.log('PaymentSyncItemErrorProcessing', data);
        this.paymentSyncEventsError.push(data);
      });
    // .listen('.BPC\\AccountingIntegrations\\Events\\ExactConfigSaved', data => {
    //   // console.log('ExactConfigSaved', data);
    //   this.$bpcMessage.showInfoMessage({
    //     text: 'global.invoice_sync_items.exact_config_saved',
    //   });
    //   this.showPaymentSyncSettingForm = false;
    // })
  }

  managePaymentSyncError(error) {
    this.paymentSyncRequestSent = true;
    this.isSyncingPayments = false;
    const exceptionType = error?.response?.data?.exception;
    const message = error?.response?.data?.message;
    switch (exceptionType) {
      case 'BPC\\AccountingIntegrations\\Exceptions\\TenantNotReadyToSyncInvoicesException':
        this.$bpcMessage.showErrorMessage({ text: message });
        this.showPaymentSyncCenterSettingForm();
        break;
      default:
        this.$bpcMessage.showErrorMessage({
          text: 'global.invoices_to_sync_item.error',
        });
        break;
    }
  }

  showPaymentSyncCenterSettingForm() {
    this.showPaymentSyncSettingForm = true;
  }
}
